<template>
    <div>
        <b-table class="mt-2" select-mode="single" v-on:row-clicked="rowSelected" bordered responsive hover :items="tracksFromProp" thead-class="d-none" />
        <b-row>
            <b-col>
                <b-button block to="/tracks" variant="secondary">
                    None of these
                </b-button>
            </b-col>
<!--            <b-col>-->
<!--                <b-button block @click="chooseChoon" variant="default">-->
<!--                    Select Tune!-->
<!--                </b-button>-->
<!--            </b-col>-->
        </b-row>
    </div>
</template>

<script>
    import { EventBus } from "../../EventBus";
    import _ from 'lodash';

    export default {
        name: "TrackSelector",
        props: ['tracks'],
        methods: {
            rowSelected(item, index) {
                this.selectedTrack = null;
                this.selectedTrack = this.originalTracks[index];
                this.chooseChoon();
            },
            chooseChoon() {
                if (this.selectedTrack) {
                    this.$store.dispatch('addToSelectedTracks', this.selectedTrack).then(() => {
                        this.selectedTrack = null;
                        EventBus.$emit('message', {message: 'Choon added to your crate', type: 'success'});
                        this.$router.push('/my-tracks');
                    }).catch(err => {
                        this.selectedTrack = null;
                        if (err === 'Track limit reached') {
                            this.$router.push('/my-tracks');
                        } else {
                            EventBus.$emit('message', {message: 'Oops this isn’t working, don’t worry please show your host to resolve it', type: 'danger'});
                        }
                    });
                }
            }
        },
        data() {
            return {
                selectedTrack: null,
                tracksFromProp: [],
                originalTracks: []
            }
        },
        watch: {
            tracks(newVal) {
                if (newVal.length > 0) {
                    this.originalTracks = newVal;
                    _.forEach(this.originalTracks, (track) => {
                        this.tracksFromProp.push(processTrackToOneLine(track));
                    });
                }
            }
        }
    }

    function processTrackToOneLine(obj) {
        return {track: `${obj.artist} - ${obj.track}`};
    }
</script>

<style scoped>

</style>
